import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "qa-edit-event-form b-add-edit__form" }
const _hoisted_2 = { class: "b-event-form" }
const _hoisted_3 = { class: "b-add-edit__form--header h-flex h-flex-center h-flex-space-between" }
const _hoisted_4 = { style: {"text-align":"left","width":"100%"} }
const _hoisted_5 = { class: "qa-edit-event-form__title h-font-16 h-m-0" }
const _hoisted_6 = {
  class: "qa-edit-event-form__button__text",
  style: {"text-align":"right","width":"100%"}
}
const _hoisted_7 = { class: "b-add-reserved-slot-form__label" }
const _hoisted_8 = { class: "qa-all-day-title" }
const _hoisted_9 = { class: "b-add-reserved-slot-form__label h-flex-space-between" }
const _hoisted_10 = { class: "qa-date-from-part__title" }
const _hoisted_11 = { class: "h-flex" }
const _hoisted_12 = { class: "h-pos-rel b-calendar-select__week fw-select-base fw-select-base__time h-flex-1-0 h-width-105" }
const _hoisted_13 = {
  key: 0,
  class: "h-pos-rel b-calendar-select__time qa-time-from-part__picker fw-select-base fw-select-base__time h-flex-1-0 h-width-105"
}
const _hoisted_14 = { style: {"max-width":"155px"} }
const _hoisted_15 = { class: "b-add-reserved-slot-form__label h-flex-space-between" }
const _hoisted_16 = { class: "h-flex" }
const _hoisted_17 = {
  key: 0,
  class: "h-pos-rel b-calendar-select__time fw-select-base fw-select-base__time h-flex-1-0 h-width-105"
}
const _hoisted_18 = {
  key: 0,
  class: "h-mb-20"
}
const _hoisted_19 = { class: "h-flex h-flex-center h-flex-space-between h-height-100p" }
const _hoisted_20 = {
  key: 0,
  class: "qa-private-event-title"
}
const _hoisted_21 = {
  key: 1,
  class: "qa-private-event-title"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "h-flex h-flex-center h-flex-space-between h-height-100p" }
const _hoisted_24 = { class: "qa-private-event-title" }
const _hoisted_25 = {
  key: 1,
  class: "h-pv-20"
}
const _hoisted_26 = { class: "h-flex-center b-add-edit__form__info" }
const _hoisted_27 = { class: "b-add-edit__form__info__text" }
const _hoisted_28 = { class: "b-add-edit__form--required h-font-14 h-fw-500 h-mb-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!
  const _component_UserFormList = _resolveComponent("UserFormList")!
  const _component_FwHorizontalScroll = _resolveComponent("FwHorizontalScroll")!
  const _component_FwSwitcher = _resolveComponent("FwSwitcher")!
  const _component_FwLabelCard = _resolveComponent("FwLabelCard")!
  const _component_FwDatepicker = _resolveComponent("FwDatepicker")!
  const _component_AddOrEditEventFormOptions = _resolveComponent("AddOrEditEventFormOptions")!
  const _component_LocationFeature = _resolveComponent("LocationFeature")!
  const _component_RecurrenceFeature = _resolveComponent("RecurrenceFeature")!
  const _component_RecurrenceEndFeature = _resolveComponent("RecurrenceEndFeature")!
  const _component_NotificationFeature = _resolveComponent("NotificationFeature")!
  const _component_NotificationSecondFeature = _resolveComponent("NotificationSecondFeature")!
  const _component_AddToRoomPopup = _resolveComponent("AddToRoomPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FwButton, {
          color: "transparent",
          style: {"color":"#D71254","min-width":"100px"},
          fontSize: "12px",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("close")))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('BUTTON.CANCEL')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.isEdit ? _ctx.$t('ADD.EVENT.EDIT.TITLE') : _ctx.$t('ADD.EVENT.ADD.TITLE')), 1),
        _createVNode(_component_FwButton, {
          class: _normalizeClass(["qa-edit-event-form__button b-add-edit__form--header-text", { "h-block-for-events": _ctx.isChangeEventRequestSending }]),
          color: "transparent",
          fontSize: "12px",
          disabled: !_ctx.isAddOrEditFormValid || !_ctx.isDayStartValid || !_ctx.isDayEndValid || _ctx.isYearlyWithoutEndDate,
          style: {"min-width":"100px","text-align":"right"},
          onClick: _ctx.postEvent
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.isEdit ? _ctx.$t('BUTTON.SAVE') : _ctx.$t('BUTTON.ADD')), 1)
          ]),
          _: 1
        }, 8, ["class", "disabled", "onClick"])
      ]),
      _createElementVNode("form", null, [
        _createVNode(_component_FwFormInput, {
          class: "h-mb-25",
          fieldHasError: _ctx.fieldHasErrorByRule(_ctx.name, _ctx.NAME, _ctx.nameRules),
          labelType: "label-thin",
          title: `${_ctx.$t(`EVENT.FORM.LABEL.NAME`)}*`
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["b-input-lock-wrapper", { "b-input-lock-wrapper--disabled": _ctx.isLimitedEdit || _ctx.isFutureEdit }])
            }, [
              _createVNode(_component_FwInput, {
                value: _ctx.name,
                disabled: _ctx.isLimitedEdit || _ctx.isFutureEdit,
                class: "qa-event-name",
                type: "text",
                inputStyle: "gray",
                iconLeft: "label-icon",
                error: _ctx.getFieldErrorTextByRule(_ctx.name, _ctx.NAME, _ctx.nameRules),
                placeholder: _ctx.$t("EVENT.NAME.INPUT"),
                onUpdate: _cache[1] || (_cache[1] = value => _ctx.name = value),
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearServerErrorsBase(_ctx.NAME))),
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addCurrentInputToValidateArray(_ctx.NAME)))
              }, null, 8, ["value", "disabled", "error", "placeholder"]),
              (_ctx.isLimitedEdit || _ctx.isFutureEdit)
                ? (_openBlock(), _createBlock(_component_FwIcon, {
                    key: 0,
                    class: "h-mh-5 b-input-lock-wrapper__icon",
                    icon: "lock",
                    size: "20",
                    color: "#BEC7D3"
                  }))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"]),
        (!_ctx.isEdit && _ctx.userPermissionOnlyAdmin)
          ? (_openBlock(), _createBlock(_component_FwFormInput, {
              key: 0,
              class: "h-mb-25",
              disabled: _ctx.isFutureEdit,
              labelType: "label-thin",
              title: `${_ctx.$t(`EVENT.FORM.LABEL.ASSIGNED.TO`)}*`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FwHorizontalScroll, {
                  isPageLoaded: true,
                  style: _normalizeStyle(_ctx.scrollStyle),
                  slotWrapperClass: "h-flex h-flex-dir-column h-height-auto-force",
                  iconClass: "h-opacity-1",
                  newClass: "fw-arrow-big-circle",
                  newClassModifier: "fw-arrow-big-circle--middle-size",
                  arrowBgWidth: null,
                  colorIcon: "#fff",
                  btnLocation: "between"
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_UserFormList, {
                      users: _ctx.usersWithoutSites,
                      userFilterId: _ctx.userFilterId,
                      onClick: _ctx.addActiveUser
                    }, null, 8, ["users", "userFilterId", "onClick"])
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            }, 8, ["disabled", "title"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (!_ctx.userSiteData)
            ? (_openBlock(), _createBlock(_component_FwFormInput, {
                key: 0,
                class: "h-mb-25 qa-all-day-part",
                fieldHasError: false,
                labelType: "label-thin",
                title: `${_ctx.$t(`EVENT.FORM.LABEL.DURATION`)}*`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FwLabelCard, {
                    class: "h-mb-10",
                    height: "50px",
                    disabled: _ctx.isLimitedEdit,
                    padding: "0 20px"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["b-add-reserved-slot-form__label__text", { "b-add-reserved-slot-form__label__text--active": _ctx.allDayIsActive }])
                        }, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('ADD.RESERVED.SLOT.FORM.ALL_DAY')), 1)
                        ], 2),
                        (_ctx.isLimitedEdit)
                          ? (_openBlock(), _createBlock(_component_FwIcon, {
                              key: 0,
                              class: "h-mh-5 b-input-lock-wrapper__icon",
                              icon: "lock",
                              size: "20",
                              color: "#BEC7D3"
                            }))
                          : (_openBlock(), _createBlock(_component_FwSwitcher, {
                              key: 1,
                              isActive: _ctx.allDayIsActive,
                              isRequestSending: false,
                              onToggleSwitch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.allDayIsActive = !_ctx.allDayIsActive))
                            }, null, 8, ["isActive"]))
                      ])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          _createVNode(_component_FwLabelCard, {
            class: "h-mv-20 qa-date-from-part",
            height: "50px",
            errorClass: !_ctx.isDayStartValid,
            disabled: _ctx.isLimitedEdit,
            padding: "0 20px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(["b-add-reserved-slot-form__label__text h-uppercase h-mr-10", { "b-add-reserved-slot-form__label__text--active": _ctx.endRecurrenceIsActive }])
                }, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('SETTINGS.CALENDAR.FROM')), 1)
                ], 2),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_FwDatepicker, {
                      modelValue: _ctx.startDay,
                      calendarPanelKey: _ctx.calendarPanelKey,
                      class: "b-add-reserved-slot-form__day_datepicker qa-date-from-part__picker",
                      name: "datepicker",
                      propsRange: false,
                      selectMode: false,
                      disabled: _ctx.disableStartDay || _ctx.isLimitedEdit || _ctx.isFutureEdit,
                      propsLang: `${_ctx.$i18n.locale}`,
                      propsFormat: "DD MMM YY",
                      hideIcon: true,
                      pickerStyle: "form",
                      iconName: "arrow-bottom",
                      iconSize: "10",
                      customArrowColor: true,
                      iconRight: true,
                      disabledDate: _ctx.disabledDateByObjectStartDay,
                      defaultValue: _ctx.date,
                      propsInputClass: "h-text-center",
                      onSelectDate: _ctx.changeEndDate
                    }, {
                      icon: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("   ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue", "calendarPanelKey", "disabled", "propsLang", "disabledDate", "defaultValue", "onSelectDate"])
                  ]),
                  (!_ctx.allDayIsActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_FwDatepicker, {
                            modelValue: _ctx.timeFrom,
                            name: "datepicker",
                            propsType: "time",
                            disabled: _ctx.isLimitedEdit,
                            placeholder: "HH:mm",
                            propsRange: false,
                            selectMode: false,
                            propsLang: `${_ctx.$i18n.locale}`,
                            propsFormat: _ctx.timeFormat,
                            hideIcon: true,
                            editStatus: true,
                            disabledTime: _ctx.lunchIntervalTime,
                            pickerStyle: "time",
                            iconSize: "0",
                            iconRight: false,
                            propsInputClass: "h-text-center",
                            propsTimePickerOptions: _ctx.timeSiteStart,
                            onSelectDate: _cache[5] || (_cache[5] = value => _ctx.timeFrom = value)
                          }, null, 8, ["modelValue", "disabled", "propsLang", "propsFormat", "disabledTime", "propsTimePickerOptions"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLimitedEdit)
                    ? (_openBlock(), _createBlock(_component_FwIcon, {
                        key: 1,
                        class: "h-mh-5 b-input-lock-wrapper__icon",
                        icon: "lock",
                        size: "20",
                        color: "#BEC7D3"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["errorClass", "disabled"]),
          _createVNode(_component_FwLabelCard, {
            class: "h-mv-20",
            height: "50px",
            errorClass: !_ctx.isDayEndValid,
            padding: "0 20px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: _normalizeClass(["b-add-reserved-slot-form__label__text h-uppercase h-mr-10", { "b-add-reserved-slot-form__label__text--active": _ctx.endRecurrenceIsActive }])
                }, _toDisplayString(_ctx.$t('SETTINGS.CALENDAR.TO')), 3),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ "b-calendar-select--disable": _ctx.disableEndDay }, "h-pos-rel b-calendar-select__week fw-select-base fw-select-base__time h-flex-1-0 h-width-105"])
                  }, [
                    _createVNode(_component_FwDatepicker, {
                      modelValue: _ctx.endDay,
                      class: "b-add-reserved-slot-form__day_datepicker",
                      calendarPanelKey: _ctx.calendarPanelKey,
                      disabled: _ctx.disableEndDay || _ctx.isLimitedEdit || _ctx.isFutureEdit,
                      name: "datepicker2",
                      propsLang: `${_ctx.$i18n.locale}`,
                      propsRange: false,
                      selectMode: false,
                      propsFormat: "DD MMM YY",
                      hideIcon: true,
                      pickerStyle: "form",
                      iconName: "arrow-bottom",
                      iconSize: "10",
                      customArrowColor: true,
                      iconRight: true,
                      disabledDate: _ctx.disabledDateByObjectEndDay,
                      defaultValue: _ctx.date,
                      propsInputClass: "h-text-center",
                      onSelectDate: _cache[6] || (_cache[6] = value => _ctx.endDay = value)
                    }, {
                      icon: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("   ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue", "calendarPanelKey", "disabled", "propsLang", "disabledDate", "defaultValue"])
                  ], 2),
                  (!_ctx.allDayIsActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_FwDatepicker, {
                          modelValue: _ctx.timeTo,
                          name: "datepicker",
                          propsType: "time",
                          placeholder: "hh:mm",
                          propsRange: false,
                          selectMode: false,
                          propsLang: `${_ctx.$i18n.locale}`,
                          propsFormat: _ctx.timeFormat,
                          hideIcon: true,
                          editStatus: true,
                          disabledTime: _ctx.lunchIntervalTime,
                          pickerStyle: "time",
                          iconSize: "0",
                          iconRight: false,
                          propsInputClass: "h-text-center",
                          propsTimePickerOptions: _ctx.timeSiteEnd,
                          onSelectDate: _cache[7] || (_cache[7] = value => _ctx.timeTo = value)
                        }, null, 8, ["modelValue", "propsLang", "propsFormat", "disabledTime", "propsTimePickerOptions"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLimitedEdit)
                    ? (_openBlock(), _createBlock(_component_FwIcon, {
                        key: 1,
                        class: "h-mh-5 b-input-lock-wrapper__icon",
                        icon: "edit",
                        size: "20",
                        color: "#BEC7D3"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["errorClass"])
        ]),
        (!_ctx.isChooseRoomsShow)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_AddOrEditEventFormOptions, {
                title: _ctx.$t("EVENT.FORM.LABEL.OPTIONS"),
                optionsData: _ctx.optionsData,
                disabled: _ctx.isFutureEdit,
                onShowComponent: _cache[8] || (_cache[8] = componentName => _ctx.showComponent = componentName)
              }, null, 8, ["title", "optionsData", "disabled"]),
              ((_ctx.existedUserSiteData || _ctx.isRoomButtonShown || (_ctx.isEdit && _ctx.isUserKindAdvisor && !_ctx.event.freq)))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_component_FwLabelCard, {
                      disabled: (_ctx.isLimitedEdit && !_ctx.isRoomFeatureAccesseble) || _ctx.isFutureEdit,
                      class: "qa-private-event-part"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["b-add-edit__form__option h-flex h-flex-center", { "b-add-edit__form__option--active": _ctx.isActiveRoom }])
                          }, [
                            _createVNode(_component_FwIcon, {
                              class: "h-mr-20",
                              icon: "icon-door",
                              size: "20",
                              color: _ctx.isActiveRoom && _ctx.isRoomFeatureAccesseble ? "#213F6B" : "#bec7d3"
                            }, null, 8, ["color"]),
                            (_ctx.event && _ctx.event.site_id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.event.site_id && _ctx.event.site_kind === `room` ? _ctx.event.site_name : _ctx.$t('SITE.ROOM.BOOK')), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.existedUserSiteData ? _ctx.existedUserSiteData.name : _ctx.$t('SITE.ROOM.BOOK')), 1))
                          ], 2),
                          (_ctx.isLimitedEdit && !_ctx.isRoomFeatureAccesseble)
                            ? (_openBlock(), _createBlock(_component_FwIcon, {
                                key: 0,
                                class: "h-mh-5 b-input-lock-wrapper__icon",
                                icon: "lock",
                                size: "20",
                                color: "#BEC7D3"
                              }))
                            : (_openBlock(), _createBlock(_component_FwSwitcher, {
                                key: 1,
                                isActive: _ctx.isActiveRoom,
                                isRequestSending: _ctx.isRequestSending,
                                onToggleSwitch: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isActiveRoom = !_ctx.isActiveRoom))
                              }, null, 8, ["isActive", "isRequestSending"]))
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("template", null, [
                (_ctx.user.id === _ctx.userFilterId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_component_FwLabelCard, {
                        disabled: _ctx.isLimitedEdit || _ctx.isFutureEdit,
                        class: "qa-private-event-part"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["b-add-edit__form__option h-flex h-flex-center", { "b-add-edit__form__option--active": _ctx.isActivePrivate }])
                            }, [
                              _createVNode(_component_FwIcon, {
                                class: "h-mr-20",
                                icon: _ctx.isActivePrivate ? `eye-cross` : `eye`,
                                size: "20",
                                color: _ctx.isActivePrivate ? "#213F6B" : "#bec7d3"
                              }, null, 8, ["icon", "color"]),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('EVENT.PRIVATE.TITLE')), 1)
                            ], 2),
                            (_ctx.isLimitedEdit)
                              ? (_openBlock(), _createBlock(_component_FwIcon, {
                                  key: 0,
                                  class: "h-mh-5 b-input-lock-wrapper__icon",
                                  icon: "lock",
                                  size: "20",
                                  color: "#BEC7D3"
                                }))
                              : (_openBlock(), _createBlock(_component_FwSwitcher, {
                                  key: 1,
                                  isActive: _ctx.isActivePrivate,
                                  isRequestSending: _ctx.isRequestSending,
                                  onToggleSwitch: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isActivePrivate = !_ctx.isActivePrivate))
                                }, null, 8, ["isActive", "isRequestSending"]))
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.id === _ctx.userFilterId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_FwIcon, {
                            class: "h-mr-20 h-ml-20",
                            icon: "alert-info",
                            size: "23",
                            color: "#bec7d3"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('EVENT.FORM.LABEL.PRIVATE')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["b-input-lock-wrapper", { "b-input-lock-wrapper--disabled": _ctx.isLimitedEdit }])
                }, [
                  _createVNode(_component_FwInput, {
                    class: "qa-messenger-textarea",
                    componentType: "textarea",
                    value: _ctx.description,
                    placeholder: _ctx.$t("EVENT.FORM.PLACEHOLDER.NOTE"),
                    type: "text",
                    disabled: _ctx.isLimitedEdit || _ctx.isFutureEdit,
                    inputStyle: "messenger-textarea",
                    iconLeftTop: "notes-icon",
                    iconSize: "20",
                    onInput: _cache[11] || (_cache[11] = value => _ctx.description = value)
                  }, null, 8, ["value", "placeholder", "disabled"]),
                  (_ctx.isLimitedEdit || _ctx.isFutureEdit)
                    ? (_openBlock(), _createBlock(_component_FwIcon, {
                        key: 0,
                        class: "h-mh-5 b-input-lock-wrapper__icon",
                        icon: "lock",
                        size: "20",
                        color: "#BEC7D3"
                      }))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("p", _hoisted_28, " *" + _toDisplayString(_ctx.$t(`EVENT.FORM.LABEL.REQUIRED`)), 1)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, !_ctx.showComponent]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_FwIcon, {
        class: "b-add-edit__form__back-arrow",
        icon: "arrow-left",
        size: "10",
        color: "#213F6B",
        onClick: _ctx.showMainForm
      }, null, 8, ["onClick"]),
      (_ctx.showLocationFeature)
        ? (_openBlock(), _createBlock(_component_LocationFeature, {
            key: 0,
            location: _ctx.location,
            onSetLocation: _ctx.setLocation
          }, null, 8, ["location", "onSetLocation"]))
        : _createCommentVNode("", true),
      (_ctx.showRecurrenceFeature)
        ? (_openBlock(), _createBlock(_component_RecurrenceFeature, {
            key: 1,
            dayList: _ctx.dayList,
            recurrenceList: _ctx.recurrenceList,
            recurrence: _ctx.recurrence,
            weekIndex: _ctx.weekIndex,
            weekIndexOptions: _ctx.weekIndexOptions,
            onSetRecurrence: _ctx.setRecurrence
          }, null, 8, ["dayList", "recurrenceList", "recurrence", "weekIndex", "weekIndexOptions", "onSetRecurrence"]))
        : _createCommentVNode("", true),
      (_ctx.showRecurrenceEndFeature)
        ? (_openBlock(), _createBlock(_component_RecurrenceEndFeature, {
            key: 2,
            recurrence: _ctx.recurrence,
            endRecurrenceDate: _ctx.endRecurrenceDate,
            onSetRecurrenceEnd: _ctx.setRecurrenceEnd
          }, null, 8, ["recurrence", "endRecurrenceDate", "onSetRecurrenceEnd"]))
        : _createCommentVNode("", true),
      (_ctx.showNotificationFeature)
        ? (_openBlock(), _createBlock(_component_NotificationFeature, {
            key: 3,
            firstReminder: _ctx.first_reminder,
            onSetNotificationFeature: _ctx.setNotificationFeature
          }, null, 8, ["firstReminder", "onSetNotificationFeature"]))
        : _createCommentVNode("", true),
      (_ctx.showNotificationSecondFeature)
        ? (_openBlock(), _createBlock(_component_NotificationSecondFeature, {
            key: 4,
            secondReminder: _ctx.second_reminder,
            onSetNotificationSecondFeature: _ctx.setNotificationSecondFeature
          }, null, 8, ["secondReminder", "onSetNotificationSecondFeature"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.showComponent]
    ]),
    (_ctx.isChooseRoomsShow)
      ? (_openBlock(), _createBlock(_component_AddToRoomPopup, {
          key: 0,
          sitesArray: _ctx.sitesArray,
          dates: { from: _ctx.dateToString(_ctx.startDate), to: _ctx.dateToString(_ctx.endDate) },
          onUpdateSiteData: _ctx.updateSiteData,
          onBackToCalendar: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit("close"))),
          onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isChooseRoomsShow = false))
        }, null, 8, ["sitesArray", "dates", "onUpdateSiteData"]))
      : _createCommentVNode("", true)
  ]))
}